import React from 'react';
import axios from 'axios';
import { render, screen, fireEvent, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import Index from './index';

jest.mock('axios');

describe('PartGroup', () => {
  describe('From(new)', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          m_part_group: {},
          m_parts: []
        }
      });
      
      (axios.get as any).mockResolvedValue(promise);

      render(<Index is_edit={false}/>);

      await act(() => promise);
      
      const name = screen.getByRole("textbox", {name: "カテゴリ名"})  as HTMLInputElement;
      const display_name = screen.getByRole("textbox", {name: "カテゴリ名（患者画面）"})  as HTMLInputElement;
      const description = screen.getByRole("textbox", {name: "カテゴリ詳細"})  as HTMLInputElement;

      // Valueの確認
      expect(name.value).toBe("");
      expect(display_name.value).toBe("");
      expect(description.value).toBe("");

      // placeholderの確認
      expect(name.placeholder).toBe("例：男性用_カテゴリ２");
      expect(display_name.placeholder).toBe("例：併用薬・嗜好品・生活習慣");
      expect(description.placeholder).toBe("カテゴリ詳細を入力してください");

      // ボタン類
      expect(screen.getByText('戻る')).toBeInTheDocument();
      expect(screen.getByText('作成する')).toBeInTheDocument();
      
    });  
  });

  describe('From(edit)', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          m_part_group: {id: 1, name: "カテゴリ1_名称", description: "カテゴリ1_詳細", display_web_name: "カテゴリ1_表示名", description_web: null, m_company_id: 1, common_kbn: 0, part_count: 1},
          m_parts: [{id: 1, name: "質問1", description: "質問1_詳細"},{id: 2, name: "質問2", description: "質問2_詳細"}]
        }
      });
      
      (axios.get as any).mockResolvedValue(promise);

      render(<Index is_edit={true}/>);

      await act(() => promise);
      
      const name = screen.getByRole("textbox", {name: "カテゴリ名"})  as HTMLInputElement;
      const display_name = screen.getByRole("textbox", {name: "カテゴリ名（患者画面）"})  as HTMLInputElement;
      const description = screen.getByRole("textbox", {name: "カテゴリ詳細"})  as HTMLInputElement;

      // Valueの確認
      expect(name.value).toBe("カテゴリ1_名称");
      expect(display_name.value).toBe("カテゴリ1_表示名");
      expect(description.value).toBe("カテゴリ1_詳細");

      // placeholderの確認
      expect(name.placeholder).toBe("例：男性用_カテゴリ２");
      expect(display_name.placeholder).toBe("例：併用薬・嗜好品・生活習慣");
      expect(description.placeholder).toBe("カテゴリ詳細を入力してください");

      // ボタン類
      expect(screen.getByText('戻る')).toBeInTheDocument();
      expect(screen.getByText('更新する')).toBeInTheDocument();
      
    });  
  }); 
});

